module.exports = __webpack_public_path__ + "img/20.baf9e829.jpg";